import { render, staticRenderFns } from "./InfoSubBlock.vue?vue&type=template&id=0e03431c&functional=true&"
import script from "./InfoSubBlock.vue?vue&type=script&lang=js&"
export * from "./InfoSubBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports